import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import MainView from "../views/MainView.vue";
import EditorView from "../views/EditorView.vue";
import RegisterUser from "@/components/RegisterUser.vue";
import AdminDashboard from '../components/AdminDashboard.vue';
import ReviewView from '../views/ReviewView.vue';
import { supabase } from "@/supabase";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: MainView,
  },
  {
    path: "/editor",
    name: "editor",
    component: EditorView,
  },
  {
    path: "/register", name: "register", component: RegisterUser
  },
  {
    path: '/admin',
    name: 'adminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/review",
    name: "review",
    component: ReviewView,
    meta: { requiresAuth: true, requiresReviewer: true },
  },  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard
router.beforeEach(async (to, from, next) => {
  //const { data: { user } } = await supabase.auth.getUser();
  const { data: { session } } = await supabase.auth.getSession();
  const user = session?.user ?? null;
  if (to.meta.requiresAuth && !user) {
    return next({ name: 'home' });
  }

  if (user && (to.meta.requiresAdmin || to.meta.requiresReviewer)) {
    const { data: profile, error } = await supabase
      .from("profiles")
      .select("isadmin, isreviewer, isapproved")
      .eq("user_id", user.id)
      .maybeSingle();

    if (error || !profile?.isapproved) {
      return next({ name: "home" });
    }

    // admin?
    if (to.meta.requiresAdmin && !profile.isadmin) {
      return next({ name: "home" });
    }

    // reviewer? (admin também passa)
    if (to.meta.requiresReviewer && !(profile.isadmin || profile.isreviewer)) {
      return next({ name: "home" });
    }
  }

  next();
});

export default router;
